// Libs
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
// Components, Layouts, Pages
import { Header, Sidebar, SidebarContainer } from '~/layouts/main/components';
// Others
import { PageHeaderProvider } from '~/context';
import { getProfile } from '~/thunks/user/userThunk';
import { useAppDispatch, useAppSelector } from '~/utils/redux/hooks';
// Styles, images, icons
import styles from './Main.module.scss';

const cx = classNames.bind(styles);

const Main = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const dispatch = useAppDispatch();
  //#endregion Declare Hook

  //#region Selector
  const { isRefreshProfile } = useAppSelector((state) => state.user);
  //#endregion Selector

  //#region Declare State
  const [isCollapse, setCollapse] = useState<boolean>(false);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    getProfileUser();
  }, [isRefreshProfile]);
  //#endregion Implement Hook

  //#region Handle Function
  const toggleCollapseSidebar = () => {
    setCollapse(!isCollapse);
  };

  const getProfileUser = () => {
    dispatch(getProfile())
      .unwrap()
      .then((_resp) => {})
      .catch(() => {})
      .finally(() => {});
  };
  //#endregion Handle Function

  return (
    <div id='maidLayout' className={cx('mainContainer')}>
      <SidebarContainer isCollapse={isCollapse} className={cx('sidebarSection')}>
        <Sidebar collapse={isCollapse} onToggle={toggleCollapseSidebar} />
      </SidebarContainer>

      <section className={cx('contentGroupSection')}>
        <PageHeaderProvider>
          <Header />

          <section id='mainContentSection' className={cx('contentSection')}>
            <Outlet />
          </section>
        </PageHeaderProvider>
      </section>
    </div>
  );
};

export default Main;
